import Model from './Model'
import ReportProcessAnnotation from './ReportProcessAnnotation'

export default class ReportField extends Model {
  id: number
  name: string
  title: string
  required: boolean
  dropoff: boolean
  orientation: string

  annotations = []
  dropoffAnnotations = []

  hasImages: boolean
  picturePath: string
  dropoffPicturePath: string

  value: string = null
  dropoffValue: string = null

  constructor(process, locale) {
    super({})
    this.id = process.id
    this.name = process.name
    this.title = this.translateField(process._title, locale)
    this.required = process.required
    this.dropoff = process.dropoff
    this.orientation = process.orientation

    this.annotations = Array.isArray(process.infos) ? process.infos
        .map((annotation) => new ReportProcessAnnotation(annotation, locale)) : []

    this.dropoffAnnotations = Array.isArray(process.dropoff_infos) ? process.dropoff_infos
        .map((annotation) => new ReportProcessAnnotation(annotation, locale)) : []

    this.picturePath = process._picture ? process._picture.path : null
    this.dropoffPicturePath = process._dropoff_picture ? process._dropoff_picture.path : null

    this.value = this.picturePath ? this.picturePath : null
    this.dropoffValue = this.dropoffValue ? this.picturePath : null

    this.hasImages = !!this.picturePath || !!this.dropoffPicturePath
  }
}
